import React, { Component } from "react";
import Select, { components, MultiValueGenericProps  } from "react-select";
import { Link } from "react-router-dom";
import ReactTooltip from "react-tooltip";

import PageHeader from "../../../components/pageHeader/pageHeader";
import BreadcrumbBar from "../../../components/breadcrumbBar";
import MQSGUtil from "../../../components/mqsgUtil";
import tableConfig from "./searchConfig";
import "./search.css";
import LoaderSpin from "../../../components/LoaderSpin";
import { MultiSelect } from "react-multi-select-component";
import { withRouter } from "react-router-dom";
import { CSVLink } from "react-csv";

const type = [
  { value: "all", label: "Call/Put" },
  { value: "call", label: "Call" },
  { value: "put", label: "Put" },
];

const moneyness = [
  { value: "all", label: "All moneyness" },
  { value: "atm", label: "At the money" },
  { value: "itm", label: "In the money" },
  { value: "otm", label: "Out of the money" },
];

const maturity = [
  { value: "all", label: "All maturity" },
  { value: "lt1", label: "< 1 month" },
  { value: "btw1t2", label: "1-2 months" },
  { value: "btw3t5", label: "3-5 months" },
  { value: "btw6t9", label: "6-9 months" },
  { value: "mt9", label: "> 9 months" },
];

const effectiveGearing = [
  { value: "all", label: "All Eff. gearing" },
  { value: "ls5", label: "< 5x" },
  { value: "btw5t10", label: "5-10x" },
  { value: "btw10t15", label: "10-15x" },
  { value: "mt15", label: "> 15x" },
];
const indicator = [
  { value: "all", label: "All indicators" },
  { value: "HIGHLQDY", label: "Highest liquidity" },
  { value: "APPCHEXPRY", label: "Near Expiry" },
  { value: "HIGHRESP", label: "Responsive" },
  { value: "HOTLIST", label: "Trending warrants" },
  { value: "SOLDOUT", label: "Inventory sold-out" },
  { value: "LOWTIMEDECAY", label: "Low time decay" },
];
const MenuList = (props) => {
  // var { onRicChange, onMenuClose } = props.selectProps;
  const { onSelectionChange } = props.selectProps;
  const getValue = (i, index) => {
    // onRicChange(i);
    // onMenuClose()
    onSelectionChange('issuer', i, index)
  };
  return (
    <components.MenuList {...props}>
      {props.options.map((i, index) => {
        return (
          <div
            key={i.label}
            className="selectSption00"
            style={{
              textAlign: "left",
              padding: "5px 10px",
              cursor: "pointer",
            }}

          >
            <input
              type="checkbox"
              value='666'
              style={{ marginRight: '10px' }}
              checked={i.check}
              onChange={(e) => {
                getValue(i, index);
              }} />
            {i.label}
          </div>
        );
      })}
    </components.MenuList>
  );
};
const MultiValue  = (props) => {
    var name = '';
    // 处理props.children，确保它是一个字符串
    const childrenStr = Array.isArray(props.children) ? props.children.join('') : props.children;
    var first =  childrenStr.lastIndexOf('(');
    var last =  childrenStr.lastIndexOf(')');
      if(first!=-1 && last!=-1){
        name = childrenStr.slice(first+1,last)
      }else{
        name = childrenStr
      }
    return (
        <components.MultiValue {...props} >
                <div>
                    {name}
                </div>    
        </components.MultiValue>
    );
  };
const isFieldAllData =(array,index)=> {
    let selectData = [
      { value: "all", label: "All underlying" },
      { label: "MACQ", value: "MACQ" },
      { value: "all", label: "All maturity" },
      { value: "all", label: "All expiry" },
      { value: "all", label: "All Eff. gearing" },
      { value: "all", label: "All indicators" },
      { value: "all", label: "All moneyness" }
    ]
      if(array.length==0){
        return [selectData[index]];
      }
      if(array[array.length-1].value == 'all'){
        let arr =  array.filter((e)=>{
          return e.value == 'all'
        })
        return arr;
      }else{
        let arr = array.filter((e)=>{
          return e.value != 'all'
        })
        return arr;
      }
  }
//select underlying
const colourStyles1 = {
  option: (provided, state) => {
    return {
      backgroundColor: state.isFocused
        ? "#007fff"
        : ["1", "2","3","4","5","6"].includes(state.innerProps.id.split("-")[4])
        ? "#FECC0A"
        : null,
      color: "#333",
      color: state.isFocused ? "#ffffff" : null,
      padding: "3px 14px 3px 5.6px",
      cursor: "pointer",
      borderTop: state.isFocused ? "1px solid #003eff" : null,
      borderBottom: state.isFocused ? "1px solid #003eff" : null,
    };
  },
  valueContainer:(provided)=>{
    return{
      ...provided,
      flexWrap:'nowrap',
      overflow: 'auto'
    }
  },
  input:(provided)=>{
    return{
      ...provided,
      flex:1
    }
  },
  multiValue:(provided)=>{
    return{
      ...provided,
      minWidth:'auto'
    }
  }
};
const colourStyles2 = {
  option: (provided, state) => {
    return {
      backgroundColor: state.isFocused ? "#f5f5f5" : null,
      color: "#333",
      fontSize: "14px",
      padding: "5px 20px",
      cursor: "pointer"
    };
  },
  valueContainer:(provided)=>{
    return{
      ...provided,
      flexWrap:'nowrap',
      overflow: 'auto'
    }
  },
  input:(provided)=>{
    return{
      ...provided,
      flex:1,
    }
  },
  multiValue:(provided)=>{
    return{
      ...provided,
      minWidth:'auto'
    }
  }
};
const colourStyles3 = {
    option: (style, { isSelected, isFocused }) => {
      return {
        ...style,
        backgroundColor: isFocused ? null : null,
        color: "blue",
        fontSize: "20px",
        padding: "0px 20px",
        cursor: "pointer",
      };
    },
  };
class WarrantSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      underlying: "all",
      maturity: "all",
      expiry: "All expiry",
      type: "Call/Put",
      effectiveGearing: "all",
      indicator: "all",
      moneyness: "all",
      issuer: "MBL",
      moneynessPercent: "all",
      sortBy: "",
      sortOrder: "",
      allData: null,
      data: null,
      initData: {
        underlyingList: [
          {
            value: "all",
            label: "All underlying",
            underlying_ticker: "all",
            underlying_name: "all",
          },
          { value: "Indices", label: "Indices", underlying_ticker: 'Indices', underlying_name: 'Indices' },
          { value: "usindices", label: "US indices", underlying_ticker: 'usindices', underlying_name: 'US indices' },
          { value: "asianindices", label: "Asian indices", underlying_ticker: 'asianindices', underlying_name: 'Asian indices' },
          { value: "hkstocks", label: "Hong Kong stocks", underlying_ticker: 'hkstocks', underlying_name: 'Hong Kong stocks' },
          { value: "sgstocks", label: "Singapore stocks", underlying_ticker: 'sgstocks', underlying_name: 'Singapore stocks' },
          { value: "exchangeTradedFunds", label: "Exchange Traded Funds (ETF)", underlying_ticker: 'exchangeTradedFunds', underlying_name: 'Exchange Traded Funds (ETF)' },
        ],
        issuerList: [],
        expiryDateList: [{ value: "all", label: "All expiry" }],
      },
      isLoading: true,
      isLoading2: true,
      underlyingSelected: [],
      maturitySelected: [],
      expirySelected: [],
      typeSelected: [],
      effectiveGearingSelected: [],
      indicatorSelected: [],
      moneynessSelected: [],
      issuerSelected: [],
      csvData:[],
      csvHeader:[
        { label: "Warrant code", key: "dwSymbol" },
        { label: "Underlying", key: "underlyingSymbol_value" },
        { label: "Type", key: "type" },
        { label: "Exercise price (Strike)", key: "Exercise_value" },
        { label: "WPS", key: "WPS_valu" },
        { label: "Last trading date", key: "ltDate" },
        { label: "Issuer", key: "issuer" },
        { label: "Bid volume ('000)", key: "bidVolume_f" },
        { label: "Bid (SGD)", key: "bidPrice_f" },
        { label: "Ask (SGD)", key: "askPrice_f" },
        { label: "Ask volume ('000)", key: "askVolume_f" },
        { label: "Traded volume ('000)", key: "tradeVolume_f" },
        { label: "Price change (%)", key: "priceChange_f" },
        { label: "Delta (%)", key: "delta" },
        { label: "Sensitivity", key: "sensitivity" },
        { label: "Eff. gearing (x)", key: "effectiveGearing" },
        { label: "Volatility (%)", key: "impliedVolalitiy" },
        { label: "Estimated decay", key: "Estimated_valu" },
      ]
    };
  }

  componentDidMount() {
        let url = MQSGUtil.getAPIBasePath() + "/ScreenerJSONServlet?init=1";
        fetch(url)
          .then((res) => {
            if (!res.ok) {
              throw new Error(`HTTP error! status: ${res.status}`);
            }
            return res.text().then(text => {
              if (!text || text.trim().startsWith('<')) {
                return {};
              }
              return JSON.parse(text);
            });
          })
          .then(
            (result) => {
              const initData = result;
              const initDataNew = { ...this.state.initData };
              var params = new URLSearchParams(this.props.location.search);
              var underlyingRes = MQSGUtil.getData(initData, "underlyings", []);
              if (!Array.isArray(underlyingRes)) underlyingRes = [];
              const tempIssues = MQSGUtil.getData(initData, "issuers", []);
              if (!Array.isArray(tempIssues)) tempIssues = [];
              const expiryDatesRes = MQSGUtil.getData(initData, "expiryDates", []);
              if (!Array.isArray(expiryDatesRes)) expiryDatesRes = [];
              var tempUnderLying = underlyingRes.map(
                (underlying) => 
                  {
                    const underlying_ticker = MQSGUtil.getData(
                    underlying,
                    "underlying_ticker"
                    );
                    const underlying_ric = MQSGUtil.getData(
                      underlying,
                      "underlying_ric"
                    );
                    const underlying_name = MQSGUtil.getData(
                      underlying,
                      "underlying_name"
                    );
                    const label = MQSGUtil.getUnderlyingTickerDisplayName(underlying_ric, underlying_ticker);
                    return {
                      underlying_ticker,
                      underlying_name,
                      label,
                      value: underlying_ticker,
                    }
                  }
              );
              tempUnderLying = [...this.state.initData.underlyingList, ...tempUnderLying];
              initDataNew["underlyingList"] = tempUnderLying;
              tempIssues.forEach((issuer) => {
                if (issuer !== "MBL") {
                  initDataNew["issuerList"].push({ value: issuer, label: issuer });
                } else {
                  initDataNew["issuerList"].push({ value: issuer, label: "MACQ" });
                }
              });
              expiryDatesRes.forEach((expiryDate) => {
                initDataNew["expiryDateList"].push({
                  value: expiryDate,
                  label: expiryDate,
                });
              });
              const queryUnderlying = params.get('underlying'); 
              const queryExpiry = params.get('expiry');         
              const queryIssuer = params.get('issuer');  
              const queryMaturity = params.get('maturity');  
              const queryType = params.get('type');  
              const queryEffectiveGearing = params.get('effectiveGearing');  
              const queryIndicator = params.get('indicator');  
              const queryMoneyness = params.get('moneyness');  
              let selectedUnderlyingValue = []
              if(queryUnderlying!='' &&queryUnderlying!=null){
                var underlyingValue = queryUnderlying.split(',')
                for(let i=0;i<underlyingValue.length;i++){
                  for(let j=0;j<tempUnderLying.length;j++){
                    if(tempUnderLying[j].value.toLowerCase()==underlyingValue[i].toLowerCase()){
                      selectedUnderlyingValue.push(tempUnderLying[j])
                    }
                  }
                }
              }else{
                selectedUnderlyingValue=[{ value: "all", label: "All underlying" }]
              }
              let selectedIssuesValue = []
              if(queryIssuer!='' &&queryIssuer!=null){
                if(queryIssuer.toLowerCase() === 'all') {
                  selectedIssuesValue = initDataNew["issuerList"];
                } else {
                  var underlyingValue = queryIssuer.split(',')
                  for(let i=0;i<underlyingValue.length;i++){
                    for(let j=0;j<initDataNew["issuerList"].length;j++){
                      if(initDataNew["issuerList"][j].value.toLowerCase()==underlyingValue[i].toLowerCase()){
                        selectedIssuesValue.push(initDataNew["issuerList"][j])
                      }
                    }
                  }
                }
              }else{
                selectedIssuesValue=[{label: "MACQ", value: "MBL"}]
              }
              let selectedMaturityValue = [];
              if(queryMaturity!='' &&queryMaturity!=null){
                var underlyingValue = queryMaturity.split(',')
                for(let i=0;i<underlyingValue.length;i++){
                  for(let j=0;j<maturity.length;j++){
                    if(maturity[j].value.toLowerCase()==underlyingValue[i].toLowerCase()){
                      selectedMaturityValue.push(maturity[j])
                    }
                  }
                }
              }else{
                selectedMaturityValue=[{ value: "all", label: "All maturity" }]
              }
              let selectedExpiryValue = [];
              if(queryExpiry!='' &&queryExpiry!=null){
                var underlyingValue = queryExpiry.split(',')
                for(let i=0;i<underlyingValue.length;i++){
                  for(let j=0;j<initDataNew["expiryDateList"].length;j++){
                    if(initDataNew["expiryDateList"][j].value.toLowerCase()==underlyingValue[i].toLowerCase()){
                      selectedExpiryValue.push(initDataNew["expiryDateList"][j])
                    }
                  }
                }
              }else{
                selectedExpiryValue=[{ value: "all", label: "All expiry" }]
              }
              let selectedEffectiveGearingValue = [];
              if(queryEffectiveGearing!='' &&queryEffectiveGearing!=null){
                var underlyingValue = queryEffectiveGearing.split(',')
                for(let i=0;i<underlyingValue.length;i++){
                  for(let j=0;j<effectiveGearing.length;j++){
                    if(effectiveGearing[j].value.toLowerCase()==underlyingValue[i].toLowerCase()){
                      selectedEffectiveGearingValue.push(effectiveGearing[j])
                    }
                  }
                }
              }else{
                selectedEffectiveGearingValue=[ { value: "all", label: "All Eff. gearing" }]
              }
              let selectedIndicatorValue = [];
              if(queryIndicator!='' &&queryIndicator!=null){
                var underlyingValue = queryIndicator.split(',')
                for(let i=0;i<underlyingValue.length;i++){
                  for(let j=0;j<indicator.length;j++){
                    if(indicator[j].value.toLowerCase()==underlyingValue[i].toLowerCase()){
                      selectedIndicatorValue.push(indicator[j])
                    }
                  }
                }
              }else{
                selectedIndicatorValue=[{ value: "all", label: "All indicators" }]
              }
              let selectedMoneynessValue = [];
              if(queryMoneyness!='' &&queryMoneyness!=null){
                var underlyingValue = queryMoneyness.split(',')
                for(let i=0;i<underlyingValue.length;i++){
                  for(let j=0;j<moneyness.length;j++){
                    if(moneyness[j].value.toLowerCase()==underlyingValue[i].toLowerCase()){
                      selectedMoneynessValue.push(moneyness[j])
                    }
                  }
                }
              }else{
                selectedMoneynessValue=[{ value: "all", label: "All moneyness" }]
              }
              let selectedTypeValue = {};
              if(queryType!='' &&queryType!=null){
                var underlyingValue = queryType.split(',')
                for(let i=0;i<underlyingValue.length;i++){
                  for(let j=0;j<type.length;j++){
                    if(type[j].value.toLowerCase()==underlyingValue[i].toLowerCase()){
                      selectedTypeValue = type[j]
                    }
                  }
                }
              }else{
                selectedTypeValue={ value: "all", label: "Call/Put" }
              }
              this.setExpirySelected(selectedExpiryValue);
              this.setEffectiveGearingSelected(selectedEffectiveGearingValue)
              this.setUnderlyingSelected(selectedUnderlyingValue);
              this.setMaturitySelected(selectedMaturityValue)
              this.setIndicatorSelected(selectedIndicatorValue)
              this.setMoneynessSelected(selectedMoneynessValue)
              this.setIssuerSelected(selectedIssuesValue)
              this.setTypeSelected(selectedTypeValue)
              this.setState(
                { initData: initDataNew, isLoading: false },
                () => {
                  this.onFetchAllData()
                }
              );
            },
            (error) => {
              console.error('Failed to fetch init data:', error);
              this.setState({ isLoading: false });
            }
          );
  }
  onSelectionChange(source, selected) {
    if (source in this.state) {
      let value = selected.value;
      if (source === "underlying") {
        value = selected.underlying_ticker;
      }
      if (this.state[source] !== value) {
        const optionNew = {};
        optionNew[source] = value;
        this.setState(optionNew);
      }
    }
  }

  onSubmit() {
    this.onFilterAllData();
  }

  onHandleData(jsonData) {
    let data = [];
    if ("data" in jsonData) {
      if (Array.isArray(jsonData.data)) {
        data = jsonData.data;
      }
    }
    return data;
  }
  getDaysBetweenDates(date1, date2) {
    // Calculate the number of days between two dates
    const d1 = new Date(date1);
    const d2 = new Date(date2);
    const timeDiff = Math.abs(d2.getTime() - d1.getTime());
    const dayDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
    return dayDiff;
  }
  onFetchAllData(){
    let url = "/ScreenerJSONServlet?";
    let data = new URLSearchParams({
      underlying:"all",
      type:"all",
      issuer:"all",
      maturity:"all",
      moneyness:"all",
      moneynessPercent:"all",
      effectiveGearing:"all",
      expiry:"all",
      indicator:"all",
      sortBy:"",
      sortOrder:""
    })
    url = MQSGUtil.getAPIBasePath() + url+data;
    fetch(url)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.text().then(text => text ? JSON.parse(text) : []);
      })
      .then(
        (result) => {
          const allData = this.onHandleData(result) || [];
          if (!Array.isArray(allData)) {
            this.setState({ allData: [], isLoading2: false });
            return;
          }
          allData.forEach(e => {
            e.underlyingSymbol_value=MQSGUtil.getUnderlyingTickerDisplayName(e.underlying_ric, e.underlyingSymbol);
            e.issuer = 'MACQ';
            if(isNaN(e.theta) || e.theta==0 || e.theta==null){
              e.tt = 'Nil';
            }else{
              e.tt = Number(e.theta).toFixed(4)
            }
          })
          this.setState({ allData, isLoading2: false },()=>{
            this.onFilterAllData()
          });
          this.getCsvData(allData)
        },
        (error) => {
          this.setState({ allData, isLoading2: false });
        }
      );
  }
  onFilterAllData(){
    this.setState({ isLoading2: true })
    let underlying = ''; //已过滤
    for(let i=0;i<this.state.underlyingSelected.length;i++){
      if(i==0){
        underlying+=this.state.underlyingSelected[i].value;
      }else{
        underlying+=','+this.state.underlyingSelected[i].value;
      }
    }
    let maturity = ''; //已过滤
    for(let i=0;i<this.state.maturitySelected.length;i++){
      if(i==0){
        maturity+=this.state.maturitySelected[i].value;
      }else{
        maturity+=','+this.state.maturitySelected[i].value;
      }
    }
    let moneyness = ''; //已过滤
    for(let i=0;i<this.state.moneynessSelected.length;i++){
      if(i==0){
        moneyness+=this.state.moneynessSelected[i].value;
      }else{
        moneyness+=','+this.state.moneynessSelected[i].value;
      }
    }
    let effectiveGearing = ''; //已过滤
    for(let i=0;i<this.state.effectiveGearingSelected.length;i++){
      if(i==0){
        effectiveGearing+=this.state.effectiveGearingSelected[i].value;
      }else{
        effectiveGearing+=','+this.state.effectiveGearingSelected[i].value;
      }
    }
    let expiry = ''; //已过滤
    for(let i=0;i<this.state.expirySelected.length;i++){
      if(i==0){
        expiry+=this.state.expirySelected[i].value;
      }else{
        expiry+=','+this.state.expirySelected[i].value;
      }
    }
    let indicator = ''; //已过滤
    for(let i=0;i<this.state.indicatorSelected.length;i++){
      if(i==0){
        indicator+=this.state.indicatorSelected[i].value;
      }else{
        indicator+=','+this.state.indicatorSelected[i].value;
      }
    }
    let issuer = this.state.issuerSelected.length === this.state.initData.issuerList.length
          ? "all"
          : this.state.issuerSelected.map(({ value }) => value).join(",");//已过滤
    let type = this.state.typeSelected === null ? "all" : this.state.typeSelected.value; //已过滤
    let allData = [];
    allData = this.state.allData.filter(e => {
      return underlying.split(',').some(u => {
         if(u == 'asianindices'){
          return e.underlyingTicker!='' && ['HSI','N225','SiMSCI'].includes(e.underlyingTicker);
         }else if(u == 'usindices'){
          return e.underlyingTicker!='' && ['S&P500','NDX'].includes(e.underlyingTicker);
         }else if(u == 'sgstocks'){
          return e.underlyingTicker!='' && !['DJI','NDX', 'S&P500', 'HSI', 'HSTECH', 'N225','SiMSCI'].includes(e.underlyingTicker) && !e.underlying_ric.endsWith('.HK');
         }else if(u == 'Indices'){
          return e.underlyingTicker!='' && ['DJI','NDX', 'S&P500', 'HSI', 'HSTECH', 'N225','SiMSCI'].includes(e.underlyingTicker);
         }else if(u == 'hkstocks'){
          return e.underlyingTicker!='' && e.underlying_ric.endsWith('.HK') && !['2823','3067'].includes(e.underlyingTicker);
         }else if(u == 'exchangeTradedFunds'){
          return e.underlyingTicker!='' &&  ['2823.HK','LIOP.SI','AMOE.SI','SGLD.SI'].includes(e.underlying_ric);
         }else if(u == 'all'){
          return true;
         }else{
          return e.underlyingTicker == u;
         }
      })
    })
    allData = allData.filter(e => {
      if(type == 'all'){
        return true;
      }
      if(type == 'call'){
        return e.type == 'C';
      }
      if(type == 'put'){
        return e.type == 'P';
      }
    })
    allData = allData.filter(e => {
      return maturity.split(',').some(u => {
        let maturityDays = this.getDaysBetweenDates(e.MATURITY, new Date());
        if(u == 'lt1'){
          return maturityDays < 30;
        }else if(u == 'btw1t2'){
          return maturityDays >= 30 && maturityDays <= 90;
        }else if(u == 'btw3t5'){
          return maturityDays > 90 && maturityDays <= 180;
        }else if(u == 'btw6t9'){
          return maturityDays > 180 && maturityDays <= 270;
        }else if(u == 'mt9'){
          return maturityDays > 270;
        }else if(u == 'all'){
          return true;
        }
      })
    })
    allData = allData.filter(e => {
      return moneyness.split(',').some(u => {
        // atm,itm,otm
        if(u == 'atm'){
          return e.moneyness == 'ATM';
        }else if(u == 'itm'){
          return e.moneyness == 'ITM';
        }else if(u == 'otm'){
          return e.moneyness == 'OTM';
        }else if(u == 'all'){
          return true;
        }
      })
    })
    allData = allData.filter(e => {
      return effectiveGearing.split(',').some(u => {
        if(u == 'all'){
          return true;
        }
        if(u == 'ls5'){
          return e.effectiveGearing < 5;
        }
        if(u == 'btw5t10'){
          return e.effectiveGearing >= 5 && e.effectiveGearing < 10;
        }
        if(u == 'btw10t15'){
          return e.effectiveGearing >= 10 && e.effectiveGearing < 15;
        }
        if(u == 'mt15'){
          return e.effectiveGearing >= 15;
        }
      })
    })
    allData = allData.filter(e => {
      return expiry.split(',').some(u => {
        if(u == 'all'){
          return true;
        }
        let expiryDate = new Date(u);
        let ltDate = new Date(e.ltDate);
        return expiryDate.getMonth() == ltDate.getMonth() && expiryDate.getFullYear() == ltDate.getFullYear();
      })
    })
    allData = allData.filter(e => {
      return indicator.split(',').some(u => {
        if(u == 'all'){
          return true;
        }
        return e[u.toUpperCase()] == true;
      })
    })
    allData = allData.filter(e => {
      return issuer.split(',').some(u => {
        if(u == 'all'){
          return true;
        }
        if(u =='MBL'){
          return e.issuer == 'MBL';
        }
      })
    })
    if (!this.isHome()) {
      let urlParam = '';
      urlParam+=`/tools/warrantsearch/?underlying=${encodeURIComponent(underlying)}&maturity=${maturity}`;
      urlParam+=`&expiry=${expiry}`;
      urlParam+=`&type=${this.state.typeSelected === null ? "all" : this.state.typeSelected.value}&effectiveGearing=${effectiveGearing}`;
      urlParam+=`&indicator=${indicator}&moneyness=${moneyness}&issuer=${this.state.issuerSelected.length === this.state.initData.issuerList.length? "all": this.state.issuerSelected.map(({ value }) => value).join(",")}`;
      window.history.replaceState(
        {},
        "",
        `${urlParam}`)
    }
    // 排序逻辑
    if (this.state.sortBy && this.state.sortOrder) {
      allData.sort((a, b) => {
        // 字段映射：sortby 字段名 -> 数据中的实际字段名
        const fieldMapping = {
          'wcode': 'dwSymbol',
          'ucode': 'underlyingSymbol_value',
          'ep': 'exercisePrice',
          'dwps': 'dwps',
          'ldate': 'ltDate',
          'isr': 'issuer',
          'bv': 'bidVolume',
          'bp': 'bidPrice',
          'ap': 'askPrice',
          'av': 'askVolume',
          'tv': 'tradeVolume',
          'pc': 'priceChange',
          'dlt': 'delta',
          'ss': 'sensitivity',
          'eg': 'effectiveGearing',
          'iv': 'impliedVolalitiy',
          'type': 'type',
          'tt': 'tt'
        };
        
        const dataField = fieldMapping[this.state.sortBy] || this.state.sortBy;
        let valA = a[dataField];
        let valB = b[dataField];
        
        // 处理空值
        if (valA === null || valA === undefined || valA === '') {
          return 1;
        }
        if (valB === null || valB === undefined || valB === '') {
          return -1;
        }
        
        let comparison = 0;
        
        // 特殊处理日期字段 ltDate（格式如 "28 Jul 26"）
        if (dataField === 'ltDate') {
          // 将日期字符串转换为 Date 对象
          const parseDate = (dateStr) => {
            const parts = dateStr.split(' ');
            if (parts.length !== 3) return null;
            const day = parseInt(parts[0], 10);
            const month = parts[1];
            const year = parseInt(parts[2], 10);
            const monthMap = {
              'Jan': 0, 'Feb': 1, 'Mar': 2, 'Apr': 3, 'May': 4, 'Jun': 5,
              'Jul': 6, 'Aug': 7, 'Sep': 8, 'Oct': 9, 'Nov': 10, 'Dec': 11
            };
            const monthNum = monthMap[month];
            if (isNaN(day) || monthNum === undefined || isNaN(year)) return null;
            // 处理两位年份，假设 26 表示 2026
            return new Date(year + 2000, monthNum, day);
          };
          
          const dateA = parseDate(valA);
          const dateB = parseDate(valB);
          
          if (dateA && dateB) {
            comparison = dateA.getTime() - dateB.getTime();
          } else {
            // 如果解析失败，回退到字符串比较
            valA = String(valA).toLowerCase();
            valB = String(valB).toLowerCase();
            comparison = valA > valB ? 1 : (valA < valB ? -1 : 0);
          }
        } else {
          // 判断是否为数字
          const isNumA = !isNaN(parseFloat(valA)) && isFinite(valA);
          const isNumB = !isNaN(parseFloat(valB)) && isFinite(valB);
          
          if (isNumA && isNumB) {
            // 数字比较
            comparison = parseFloat(valA) - parseFloat(valB);
          } else {
            // 字符串比较
            valA = String(valA).toLowerCase();
            valB = String(valB).toLowerCase();
            if (valA > valB) {
              comparison = 1;
            } else if (valA < valB) {
              comparison = -1;
            }
          }
        }
        
        return this.state.sortOrder === 'asc' ? comparison : -comparison;
      });
    }
    this.setState({ data:allData});
    this.getCsvData(allData)
    window.setTimeout(() => {
      this.setState({ isLoading2: false });
    }, 100);
  }
  jumpToSearch() {
    let underlying = this.state.underlyingSelected.map(item => item.value).join(',');
    let maturity = this.state.maturitySelected.map(item => item.value).join(',');
    let moneyness = this.state.moneynessSelected.map(item => item.value).join(',');
    let effectiveGearing = this.state.effectiveGearingSelected.map(item => item.value).join(',');
    let expiry = this.state.expirySelected.map(item => item.value).join(',');
    let indicator = this.state.indicatorSelected.map(item => item.value).join(',')
    let urlParam = '';
      urlParam+=`/tools/warrantsearch/?underlying=${encodeURIComponent(underlying)}&maturity=${maturity}`;
      urlParam+=`&expiry=${expiry}`;
      urlParam+=`&type=${this.state.typeSelected === null ? "all" : this.state.typeSelected.value}&effectiveGearing=${effectiveGearing}`;
      urlParam+=`&indicator=${indicator}&moneyness=${moneyness}&issuer=${this.state.issuerSelected.length === this.state.initData.issuerList.length? "all": this.state.issuerSelected.map(({ value }) => value).join(",")}`;
    this.props.history.push(urlParam);
  }
  onSorting(field, isAsc) {
    this.setState({ sortBy: field, sortOrder: isAsc }, () => {
      this.onSubmit()
    })
  }

  isHome() {
    if (this.props.page !== undefined && this.props.page !== null) {
      if (this.props.page === "home") {
        return true;
      }
    }
    return false;
  }

  renderHome() {
    return (
      <div className="holder-qlink-dwsearch">
        <div id="qlink-dwsearch">
          <div className="page-header">
            <h2 className="small">Warrant search</h2>
          </div>
          <p className="section-p">
            Find warrants according to your investment criteria.
          </p>
          <div style={{ marginBottom: "10px" }}>
            <Select
              className="warrant-search_dropdown"
              placeholder={"All Underlying"}
              value={this.state.underlyingSelected}
              onChange={(val) => {
              this.setUnderlyingSelected(isFieldAllData(val,0))
              }}
              options={this.state.initData.underlyingList}
              styles={colourStyles1}
              isMulti
              components={{ MultiValue}}
              isClearable={false}
            />
          </div>
          <div style={{ marginBottom: "10px" }}>
            <Select
                className="warrant-search_dropdown"
                placeholder={"Call/Put"}
                value={this.state.typeSelected}
                isSearchable={false}
                onChange={(val)=>this.setTypeSelected(val)}
                options={type}
                styles={colourStyles2}
              />
          </div>
          <div style={{ marginBottom: "10px" }}>
            <Select
              className="warrant-search_dropdown"
              placeholder={"All expiry"}
              value={this.state.expirySelected}
              isSearchable={false}
              onChange={(val) => {
              this.setExpirySelected(isFieldAllData(val,3))
              }}
              options={this.state.initData.expiryDateList}
              styles={colourStyles2}
              isMulti
              isClearable={false}
            />
          </div>
          <div className="section-btn-wapper section-center section-btn-wapper-mobile">
          <button
            id="searchSubmitBtn"
            type="button"
            className="btn btn-primary searchSubmitBtn"
            onClick={this.jumpToSearch.bind(this)}
          >
            Submit
          </button>
     
          <Link
            to="/tools/warrantsearch"
            type="button"
            className="btn btn-primary"
            style={{ width: "190px" }}
          >
            View all underlyings
          </Link>
        </div>
        </div>
      </div>
    );
  }
  childMethod() {
    if (this.refs.child) {
      this.refs.child.onClickTradeWarrantsHere()
    }
  }
  setUnderlyingSelected(val){
    this.setState({underlyingSelected:val})
  }
  setMaturitySelected(val){
    this.setState({maturitySelected:val})
  }
  setExpirySelected(val){
    this.setState({expirySelected:val})
  }
  setTypeSelected(val){
    this.setState({typeSelected:val})
  }
  setEffectiveGearingSelected(val){
    this.setState({effectiveGearingSelected:val})
  }
  setIndicatorSelected(val){
    this.setState({indicatorSelected:val})
  }
  setMoneynessSelected(val){
    this.setState({moneynessSelected:val})
  }
  setIssuerSelected(val){
    this.setState({issuerSelected:val})
  }
  getCsvData (data){
    if (data.length>0){
      var csvDatas = JSON.parse(JSON.stringify(data));
      csvDatas.forEach((e,i)=>{
        e.underlyingSymbol_value=MQSGUtil.getUnderlyingTickerDisplayName(e.underlying_ric, e.underlyingSymbol);
        e.Exercise_value=e.underlying_name == 'TENCENT' ? e.exercise_price_cal : e.exercisePrice;
        e.WPS_valu=e.dwps;
        if(isNaN(e.theta) || e.theta==0 || e.theta==null){
          e.Estimated_valu =  'Nil';
        }else{
          var iv = Number(e.theta).toFixed(4);
          e.Estimated_valu = iv;
        }
      })
      this.setState({csvData:csvDatas})
    }
  } 

  renderPage() {
    return (
      <div id="dwsearch" className="pageobj" onClick={() => this.childMethod()}>
        <BreadcrumbBar
          link="/home"
          group="Warrant tools"
          title="Warrant search"
        />
        <div className="stripe-bg"></div>
        <div className="container-fluid">
          <div className="section">
            <PageHeader title="Warrant search" ref="child" />
            <div className="row">
              <div className="col-sm-6" style={{ paddingLeft: 0 }}>
                <p className="section-txt">
                  Find warrants according to your investment criteria.
                  <br />
                  For more information on how to select a warrant,&nbsp;
                  <a href="/WarrantsGuidebook/howtoselectawarrant" target="_blank" style={{ color: '#0675C2' }}>
                    click here
                  </a>
                  .
                </p>
              </div>
              <div className="col-sm-6">
                <a href="/tools/warrantcalculator" target="_blank"   >
                  <img
                    style={{ width: "100%" }}
                    src="/img/bg/warrantCalculatorBanner.png"
                    alt=""
                  />
                </a>
              </div>
            </div>
            <div className="filter-groud">
              <div className="row">
                <div className="col-sm-4">
                      <div style={{ marginBottom: "10px" }}>
                        <Select
                          className="warrant-search_dropdown"
                          placeholder={"All Underlying"}
                          value={this.state.underlyingSelected}
                          onChange={(val) => {
                          this.setUnderlyingSelected(isFieldAllData(val,0))
                          }}
                          options={this.state.initData.underlyingList}
                          styles={colourStyles1}
                          isMulti
                          components={{ MultiValue}}
                          isClearable={false}
                        />
                      </div>
                      <div className="hidden-sm hidden-xs">
                        <div style={{ marginBottom: "10px" }}>
                          <Select
                            className="warrant-search_dropdown"
                            placeholder={"All Maturity"}
                            value={this.state.maturitySelected}
                            isSearchable={false}
                            onChange={(val) => {
                            this.setMaturitySelected(isFieldAllData(val,2))
                            }}
                            options={maturity}
                            styles={colourStyles2}
                            isMulti
                            isClearable={false}
                          />
                        </div>
                        <div style={{ marginBottom: "10px" }}>
                          <Select
                            className="warrant-search_dropdown"
                            placeholder={"All expiry"}
                            value={this.state.expirySelected}
                            isSearchable={false}
                            onChange={(val) => {
                            this.setExpirySelected(isFieldAllData(val,3))
                            }}
                            options={this.state.initData.expiryDateList}
                            styles={colourStyles2}
                            isMulti
                            isClearable={false}
                          />
                        </div>
                      </div>
                </div>
                <div className="col-sm-4">
                    <div style={{ marginBottom: "10px" }}>
                        <Select
                            className="warrant-search_dropdown"
                            placeholder={"Call/Put"}
                            value={this.state.typeSelected}
                            isSearchable={false}
                            onChange={(val)=>this.setTypeSelected(val)}
                            options={type}
                            styles={colourStyles2}
                          />
                      </div>
                      <div className="hidden-sm hidden-xs">
                        <div style={{ marginBottom: "10px" }}>
                          <Select
                            className="warrant-search_dropdown"
                            placeholder={"All Eff. Gearing"}
                            value={this.state.effectiveGearingSelected}
                            isSearchable={false}
                            onChange={(val) => {
                            this.setEffectiveGearingSelected(isFieldAllData(val,4))
                            }}
                            options={effectiveGearing}
                            styles={colourStyles2}
                            isMulti
                            isClearable={false}
                          />
                        </div>
                        <div style={{ marginBottom: "10px" }}>
                          <Select
                            className="warrant-search_dropdown"
                            placeholder={"All Indicators"}
                            value={this.state.indicatorSelected}
                            isSearchable={false}
                            onChange={(val) => {
                            this.setIndicatorSelected(isFieldAllData(val,5))
                            }}
                            options={indicator}
                            styles={colourStyles2}
                            isMulti
                            isClearable={false}
                          />
                        </div>
                      </div>
                </div>
                <div className="col-sm-4">
                  <div className="hidden-sm hidden-xs">
                    <div style={{ marginBottom: "10px" }}>
                      <Select
                          className="warrant-search_dropdown"
                          placeholder={"All Moneyness"}
                          value={this.state.moneynessSelected}
                          isSearchable={false}
                          onChange={(val) => {
                          this.setMoneynessSelected(isFieldAllData(val,6))
                          }}
                          options={moneyness}
                          styles={colourStyles2}
                          isMulti
                          isClearable={false}
                        />
                    </div>
                  </div>
                  <div style={{ marginBottom: "10px" }}>
                    <MultiSelect
                      label="Issuer"
                      style={colourStyles3}
                      labelledBy="Issuer"
                      avoidHighlightFirstOption={false}
                      disableSearch="false"
                      options={this.state.initData.issuerList}
                      overrideStrings={{
                        allItemsAreSelected: "All issuers",
                        selectAll: "All issuers",
                        Macquarie: "MACQ",
                        someItemsSelected: "",
                      }}
                      // defaultValue={{ label: "Ambank", value: "Ambank" }}
                      value={this.state.issuerSelected}
                      onChange={(val) => {
                        if (val.length > 0) {
                          this.setIssuerSelected(val);
                        } else {
                          this.setIssuerSelected([
                            {label: "MACQ", value: "MBL"},
                          ]);
                        }
                      }}
                    />
                  </div>
                  <div style={{ marginTop: '12px' }}>
                    <button
                      className="btn btn-primary"
                      style={{ width: "100%", height: "35px" }}
                      onClick={this.onSubmit.bind(this)}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="indicator hidden-xs hidden-sm">
              <IconMeanning />
            </div>
            <div style={{textAlign:'right'}}>
                {/* <img src="/img/bullet/rf.png" 
                  alt="Image" 
                  style={{margin:'5px',cursor:'pointer'}}
                  onClick={this.onSubmit.bind(this)}
                /> */}
                <CSVLink data={this.state.csvData} headers={this.state.csvHeader} filename={'download.csv'}>
                  <img src="/img/bullet/xz.png" alt="Image" style={{cursor:'pointer'}}/>
                </CSVLink>
            </div>
            <TableResult
              config={tableConfig}
              isLoading={this.state.isLoading2}
              result={this.state.data}
              onSorting={this.onSorting.bind(this)}
            />
            <p className="sorttip visible-xs">Click the column header to sort.</p>
            <div className="indicatortbl  hidden-md hidden-lg hidden-sm">
              <table className="indicatortbl flex">
                <tbody>
                  <tr>
                    <td>
                      <div className="indicator-item small">
                        <span className="indicator-item-icon icon-liquidity" />
                        Highest liquidity
                      </div>
                    </td>
                    <td>
                      <div className="indicator-item small">
                        <span className="icon-expiry indicator-item-icon" />
                        Near expiry
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="indicator-item small">
                        <span className="icon-responsive indicator-item-icon" />
                        Responsive
                      </div>
                    </td>
                    <td>
                      <div className="indicator-item small">
                        <span className="icon-hotdw indicator-item-icon" />
                        Trending warrants
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="indicator-item small">
                        <span className="icon-soldOut indicator-item-icon" />
                        Inventory sold-out
                      </div>
                    </td>
                    <td>
                      <div className="indicator-item small">
                        <span className="icon-lowtimedecay indicator-item-icon" />
                        Low time decay
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    if (this.state.isLoading) {
      return null;
    }
    if (this.isHome()) {
      return this.renderHome();
    } else {
      return this.renderPage();
    }
  }
}
class IconMeanning extends Component {
  render() {
    const highestliquidityTooltip = (
      <div>
        <p>
          <strong>Highest liquidity:</strong> Highlights the Macquarie warrant for each underlying with the largest volumes on the current bid and offer.
        </p>
      </div>
    );
    const nearexpiryTooltip = (
      <div>
        <p>
          <strong>Near expiry:</strong> Macquarie warrants with less than 1 month to the last trading date. These tend to be very high risk, so please trade with caution.
        </p>
      </div>
    );
    const responsiveTooltip = (
      <div>
        <p>
          <strong>Responsive:</strong> Indicates the Macquarie warrant that is most sensitive to the underlying price movements for each underlying. This is usually the one with the smallest number in the “Sensitivity” field.
        </p>
      </div>
    );
    const hotdwTooltip = (
      <div>
        <p>
          <strong>Trending warrants:</strong> The Trending warrants are chosen based on the warrants’ gearing, liquidity, sensitivity and are on tighter spreads
        </p>
      </div>
    );
    const lowTimeDecayTooltip = (
      <div>
        <p>
          <strong>Low time decay:</strong> Warrants with this indicator have relatively lower time decay, meaning lower holding costs for investors. Generally, all else constant, longer dated Warrants have lower time decay than shorter dated Warrants and vice versa.
        </p>
      </div>
    );
    const soldOutTooltip = (
      <div>
        <p>
          <strong>Inventory sold-out:</strong> Warrants with this indicator are either sold out or close to being sold out, meaning the market maker may no longer provide an offer price or have widened spreads by raising the offer price. Existing holders are not disadvantaged as the bid price is still maintained at its fair price. However, please exercise caution if you are looking to buy this Warrant as the market price may be inflated by other investors queuing in the market. Do check the Live Matrix for the warrant’s fair bid price.
        </p>
      </div>
    );
    return (
      <ul className="indicator-list list-unstyled list-inline">
        <li>
          <div
            className="indicator-item small"
            data-tip
            data-for="indicator-highestliquidity-tooltip"
          >
            <span className="icon-liquidity indicator-item-icon"></span>
            <span className="ttip" data-target="highestliquidity">
              Highest liquidity
            </span>
          </div>
          <ReactTooltip
            id="indicator-highestliquidity-tooltip"
            className="search-tooltip"
            delayHide={100}
            place="right"
            type="warning"
            effect="solid"
          >
            {highestliquidityTooltip}
          </ReactTooltip>
        </li>
        <li>
          <div
            className="indicator-item small"
            data-tip
            data-for="indicator-nearexpiry-tooltip"
          >
            <span className="icon-expiry indicator-item-icon"></span>
            <span className="ttip" data-target="nearexpiry">
              Near expiry
            </span>
          </div>
          <ReactTooltip
            id="indicator-nearexpiry-tooltip"
            className="search-tooltip"
            delayHide={100}
            place="right"
            type="warning"
            effect="solid"
          >
            {nearexpiryTooltip}
          </ReactTooltip>
        </li>

        <li>
          <div
            className="indicator-item small"
            data-tip
            data-for="indicator-responsive-tooltip"
          >
            <span className="icon-responsive indicator-item-icon"></span>
            <span className="ttip" data-target="responsive">
              Responsive
            </span>
          </div>
          <ReactTooltip
            id="indicator-responsive-tooltip"
            className="search-tooltip"
            delayHide={100}
            place="right"
            type="warning"
            effect="solid"
          >
            {responsiveTooltip}
          </ReactTooltip>
        </li>
        <li>
          <div
            className="indicator-item small"
            data-tip
            data-for="indicator-hotdw-tooltip"
          >
            <span className="icon-hotdw indicator-item-icon"></span>
            <span className="ttip" data-target="hotdw">
              Trending warrants
            </span>
          </div>
          <ReactTooltip
            id="indicator-hotdw-tooltip"
            className="search-tooltip"
            delayHide={100}
            place="right"
            type="warning"
            effect="solid"
          >
            {hotdwTooltip}
          </ReactTooltip>
        </li>
        <li>
          <div
            className="indicator-item small"
            data-tip
            data-for="indicator-soldOut-tooltip"
          >
            <span className="icon-soldOut indicator-item-icon"></span>
            <span className="ttip" data-target="soldOut">
              Inventory sold-out
            </span>
          </div>
          <ReactTooltip
            id="indicator-soldOut-tooltip"
            className="search-tooltip"
            delayHide={100}
            place="right"
            type="warning"
            effect="solid"
          >
            {soldOutTooltip}
          </ReactTooltip>
        </li>
        <li>
          <div
            className="indicator-item small"
            data-tip
            data-for="indicator-lowtimedecay-tooltip"
          >
            <span className="icon-lowtimedecay indicator-item-icon"></span>
            <span className="ttip" data-target="lowtimedecay">
              Low time decay
            </span>
          </div>
          <ReactTooltip
            id="indicator-lowtimedecay-tooltip"
            className="search-tooltip"
            delayHide={100}
            place="right"
            type="warning"
            effect="solid"
          >
            {lowTimeDecayTooltip}
          </ReactTooltip>
        </li>
      </ul>
    );
  }
}

class TableResult extends Component {
  onSorting(field, isAsc) {
    this.props.onSorting(field, isAsc);
  }

  getRowData(size) {
    const rows = [];
    if (this.props.config !== null && this.props.result !== null) {
      if ("fields" in this.props.config && this.props.result.length > 0) {
        this.props.result.forEach((data, index) => {
          let td = [];
          this.props.config.fields.forEach((field) => {
            if (this.props.config.columnShow(size, field)) {
              td.push(field.columnJsx(data, index));
            }
          });
          const tr = (
            <tr
              className={"rowtmpl-" + size + " text-bold"}
              key={index}
              idx={index}
            >
              {td}
            </tr>
          );
          rows.push(tr);
        });
      }
    }
    return rows;
  }

  getRowHeader2(size, visible = true) {
    const th = [];
    if (this.props.config !== null) {
      this.props.config.fields.forEach((field) => {
        if (this.props.config.columnShow(size, field)) {
          th.push(this.props.config.columnHeader2Jsx(size, field, visible));
        }
      });
    }
    const style = visible ? null : { height: "0px", visibility: "hidden" };
    return (
      <tr className="result-hdr2" key={"result-hdr2-" + size} style={style}>
        {th}
      </tr>
    );
  }

  getRowDataSort(size) {
    const th = [];
    if (this.props.config !== null) {
      this.props.config.fields.forEach((field) => {
        if (this.props.config.columnShow(size, field)) {
          th.push(
            this.props.config.columnSortJsx(
              size,
              field,
              this.onSorting.bind(this)
            )
          );
        }
      });
    }
    return (
      <tr className="result-sort" key={"result-sort-" + size}>
        {th}
      </tr>
    );
  }
  getUpOrDownClass(value) {
    let upDown = " val ";
    if (value.indexOf("-") > -1) {
      upDown += "down ";
    } else if (value.indexOf("+") > -1) {
      upDown += "up ";
    }
    return upDown
  }
  estimatedDecayData(warrantData){
    if(isNaN(warrantData.theta) || warrantData.theta==0 || warrantData.theta==null){
      return 'N/A'
    }else{
      var iv = Number(warrantData.theta).toFixed(3);
      return iv;
    }
  };
  render() {
    return (
      <div id="resulttable" className="result" style={{ overflowX: 'scroll' }}>
        <table
          id="faketable"
          className="hidden-sm hidden-xs"
          style={{ tableLayout: "fixed", marginBottom: "-1px" }}
        >
          <thead>
            {/* {this.getRowHeader2("lg", false)} */}
            <tr className="result-hdr2" style={{ height: '0px', visibility: 'hidden' }}>
              <th className="bgcolor-04" style={{ width: '5.15%' }}>

              </th>
              <th className="bgcolor-04 noborder" style={{ width: '4%' }}></th>
              <th className="bgcolor-04" style={{ width: '11%' }}>

              </th>
              <th className="bgcolor-04" style={{ width: '3%' }}>

              </th>
              <th className="bgcolor-04" style={{ width: '6.1%' }}>

              </th>
              <th className="bgcolor-04" style={{ width: '4.1%' }}>

              </th>
              <th className="bgcolor-04" style={{ width: '6.1%' }}>

              </th>
              <th className="bgcolor-04" style={{ width: '6.45%' }}>

              </th>
              <th className="bgcolor-05" style={{ width: '6.1%' }}>

              </th>
              <th className="bgcolor-05" style={{ width: '5.1%' }}>

              </th>
              <th className="bgcolor-05" style={{ width: '6.1%' }}>

              </th>
              <th className="bgcolor-05" style={{ width: '5.1%' }}>

              </th>
              <th className="bgcolor-05" style={{ width: '6.1%' }}>

              </th>
              <th className="bgcolor-05" style={{ width: '5%' }}>

              </th>
              <th className="bgcolor-06" style={{ width: '5.1%' }}>

              </th>
              <th className="bgcolor-06" style={{ width: '6.0%' }}>

              </th>
              <th className="bgcolor-06" style={{ width: '4.6%' }}>

              </th>
              <th className="bgcolor-06" style={{ width: '6.0%' }}>

              </th>
              <th className="bgcolor-06" style={{ width: '6.0%' }}>

              </th>
            </tr>
            <tr className="result-hdr1">
              <th className="bgcolor-04" colSpan="8">
                GENERAL
              </th>
              <th className="bgcolor-05" colSpan="6">
                MARKET
              </th>
              <th className="bgcolor-06" colSpan="5">
                WARRANT
              </th>
            </tr>
          </thead>
        </table>
        <table id="resulttable-lg" className="table-fixed">
          <thead>
            <tr className="result-hdr2 visible-lg  visible-md" >
              <th className="bgcolor-04" style={{ width: '5.15%' }}>
                <div
                  data-tip
                  data-for="indicator-Warrant-tooltip"
                >
                  <span className="ttip" data-target="wcode">Warrant<br />code</span>
                  <ReactTooltip
                    id="indicator-Warrant-tooltip"
                    className="tools-search-tooltip"
                    delayHide={100}
                    place="right"
                    type="warning"
                    effect="solid"
                  >
                    <div>
                      <p>
                        <strong>Warrant code: </strong>
                        Each warrant has an unique 4-digit identification code,
                        <a href="/WarrantsGuidebook/howarewarrantsnamed" target="_blank"> click here </a>
                        for a more detailed explanation.
                      </p>
                    </div>
                  </ReactTooltip>
                </div>
              </th>
              <th className="bgcolor-04 noborder" style={{ width: '4%' }}></th>
              <th className="bgcolor-04" style={{ width: '11%' }}>
                <div
                  data-tip
                  data-for="indicator-underlying-tooltip"
                >
                  {/* <span className="ttip" data-target="underlying">{size=='xs'?'Underlying name':'Underlying'}</span> */}
                  <span className="ttip" data-target="underlying">Underlying</span>
                  <ReactTooltip
                    id="indicator-underlying-tooltip"
                    className="tools-search-tooltip"
                    delayHide={100}
                    place="right"
                    type="warning"
                    effect="solid"
                  >
                    <div>
                      <p>
                        <strong>Underlying: </strong>
                        The stock or index over which the Warrant is listed.
                      </p>
                    </div>
                  </ReactTooltip>
                </div>
              </th>
              <th className="bgcolor-04" style={{ width: '3%' }}>
                <div
                  data-tip
                  data-for="indicator-type-tooltip"
                >
                  <span className="ttip" data-target="type">Type</span>
                  <ReactTooltip
                    id="indicator-type-tooltip"
                    className="tools-search-tooltip"
                    delayHide={100}
                    place="right"
                    type="warning"
                    effect="solid"
                  >
                    <div>
                      <p>
                        <strong>Type: </strong>
                        Calls increase in value as share price rises, Puts increase in value as share price falls.
                      </p>
                    </div>
                  </ReactTooltip>
                </div>
              </th>
              <th className="bgcolor-04" style={{ width: '6.1%' }}>
                <div
                  data-tip
                  data-for="indicator-exercisePrice-tooltip"
                >
                  <span className="ttip" data-target="exerciseprice">Exercise<br />price<br />(Strike)</span>
                  <ReactTooltip
                    id="indicator-exercisePrice-tooltip"
                    className="tools-search-tooltip"
                    delayHide={100}
                    place="right"
                    type="warning"
                    effect="solid"
                  >
                    <div>
                      <p>
                        <strong>Exercise price: </strong>
                        The price at which you can buy (calls) or sell (puts) the underlying
                        <br />
                        share or index at expiry.
                      </p>
                    </div>
                  </ReactTooltip>
                </div>
              </th>
              <th className="bgcolor-04" style={{ width: '4.1%' }}>
                <div
                  data-tip
                  data-for="indicator-dwps-tooltip"
                >
                  <span className="ttip" data-target="wps">WPS</span>
                  <ReactTooltip
                    id="indicator-dwps-tooltip"
                    className="tools-search-tooltip"
                    delayHide={100}
                    place="right"
                    type="warning"
                    effect="solid"
                  >
                    <div>
                      <p>
                        <strong>WPS: </strong>
                        The number of warrants that entitles you to one unit of the underlying share or index at expiry.
                      </p>
                    </div>
                  </ReactTooltip>
                </div>
              </th>
              <th className="bgcolor-04" style={{ width: '6.1%' }}>
                <div
                  data-tip
                  data-for="indicator-date-tooltip"
                >
                  <span className="ttip" data-target="lasttradingdate">Last<br />trading<br />date</span>
                  <ReactTooltip
                    id="indicator-date-tooltip"
                    className="tools-search-tooltip"
                    delayHide={100}
                    place="right"
                    type="warning"
                    effect="solid"
                  >
                    <div>
                      <p>
                        <strong>Last trading date: </strong>
                        The last day to buy or sell the warrant.  This date is always the 5th trading day prior to the expiry date.  For Hong Kong underlyings, the last trading date will be brought forward if the 5th trading day prior to expiry falls on a Hong Kong holiday.
                      </p>
                    </div>
                  </ReactTooltip>
                </div>
              </th>
              <th className="bgcolor-04" style={{ width: '6.45%' }}>
                <div
                  data-tip
                  data-for="indicator-isr-tooltip"
                >
                  <span className="ttip" data-target="issuer">Issuer</span>
                  <ReactTooltip
                    id="indicator-isr-tooltip"
                    className="tools-search-tooltip"
                    delayHide={100}
                    place="right"
                    type="warning"
                    effect="solid"
                  >
                    <div>
                      <p>
                        <strong>Issuer: </strong>
                        The Bank or Securities company that issues the Warrant.
                      </p>
                    </div>
                  </ReactTooltip>
                </div>
              </th>
              <th className="bgcolor-05" style={{ width: '6.1%' }}>
                <div
                  data-tip
                  data-for="indicator-MARKET-tooltip"
                >
                  <span className="ttip" data-target="bidvolume">Bid<br />volume<br />('000)</span>
                  <ReactTooltip
                    id="indicator-MARKET-tooltip"
                    className="tools-search-tooltip"
                    delayHide={100}
                    place="right"
                    type="warning"
                    effect="solid"
                  >
                    <div>
                      <p>
                        <strong>Bid volume: </strong>
                        The volume provided at the current highest bid price for the Warrant.
                      </p>
                    </div>
                  </ReactTooltip>
                </div>
              </th>
              <th className="bgcolor-05" style={{ width: '5.1%' }}>
                <div
                  data-tip
                  data-for="indicator-bp-tooltip"
                >
                  <span className="ttip" data-target="bid">Bid<br />(SGD)</span>
                  <ReactTooltip
                    id="indicator-bp-tooltip"
                    className="tools-search-tooltip"
                    delayHide={100}
                    place="right"
                    type="warning"
                    effect="solid"
                  >
                    <div>
                      <p>
                        <strong>Bid: </strong>
                        The highest current buy price of the Warrant. This is the value that most accurately reflects the 'value' of the Warrant at any point in time.
                      </p>
                    </div>
                  </ReactTooltip>
                </div>
              </th>
              <th className="bgcolor-05" style={{ width: '6.1%' }}>
                <div
                  data-tip
                  data-for="indicator-ap-tooltip"
                >
                  <span className="ttip" data-target="ask">Ask<br />(SGD)</span>
                  <ReactTooltip
                    id="indicator-ap-tooltip"
                    className="tools-search-tooltip"
                    delayHide={100}
                    place="right"
                    type="warning"
                    effect="solid"
                  >
                    <div>
                      <p>
                        <strong>Ask: </strong>
                        The lowest current sell price for the Warrant.
                      </p>
                    </div>
                  </ReactTooltip>
                </div>
              </th>
              <th className="bgcolor-05" style={{ width: '5.1%' }}>
                <div
                  data-tip
                  data-for="indicator-av-tooltip"
                >
                  <span className="ttip" data-target="askvolume">Ask<br />volume<br />('000)</span>
                  <ReactTooltip
                    id="indicator-av-tooltip"
                    className="tools-search-tooltip"
                    delayHide={100}
                    place="right"
                    type="warning"
                    effect="solid"
                  >
                    <div>
                      <p>
                        <strong>Ask volume: </strong>
                        The volume provided at the current lowest sell price for the Warrant.
                      </p>
                    </div>
                  </ReactTooltip>
                </div>
              </th>
              <th className="bgcolor-05" style={{ width: '6.1%' }}>
                <div
                  data-tip
                  data-for="indicator-tv-tooltip"
                >
                  <span className="ttip" data-target="tradedvolume">Traded volume<br />('000)</span>
                  <ReactTooltip
                    id="indicator-tv-tooltip"
                    className="tools-search-tooltip"
                    delayHide={100}
                    place="right"
                    type="warning"
                    effect="solid"
                  >
                    <div>
                      <p>
                        <strong>Traded volume: </strong>
                        Total volume traded in the Warrant for the current day. A Warrant that has not traded for the day does not necessarily mean that it is not liquid.
                        <a href="/WarrantsGuidebook/liquidityvstradedvolume" target="_blank"> Click here </a>
                        for more info about Warrant and liquidity.
                      </p>
                    </div>
                  </ReactTooltip>
                </div>
              </th>
              <th className="bgcolor-05" style={{ width: '5%' }}>
                <div
                  data-tip
                  data-for="indicator-pc-tooltip"
                >
                  <span className="ttip" data-target="pricechange">Price change<br />(%)</span>
                  <ReactTooltip
                    id="indicator-pc-tooltip"
                    className="tools-search-tooltip"
                    delayHide={100}
                    place="right"
                    type="warning"
                    effect="solid"
                  >
                    <div>
                      <p style={{ textAlign: 'left' }}>
                        <strong>Price change: </strong>
                        Current bid price for the Warrant compared to the Prior (previous days close). The bid price of the Warrant 1 minute before close of trading at 5.00pm, will be used for the Prior. For more info
                        <a href="/WarrantsGuidebook/howarewarrantspriced" target="_blank" style={{ textAlign: 'left' }}> click here </a>
                      </p>
                    </div>
                  </ReactTooltip>
                </div>
              </th>
              <th className="bgcolor-06" style={{ width: '5.1%' }}>
                <div
                  data-tip
                  data-for="indicator-dlt-tooltip"
                >
                  <span className="ttip" data-target="delta">Delta<br />(%)</span>
                  <ReactTooltip
                    id="indicator-dlt-tooltip"
                    className="tools-search-tooltip"
                    delayHide={100}
                    place="right"
                    type="warning"
                    effect="solid"
                  >
                    <div>
                      <p>
                        <strong>Delta: </strong>
                        Estimates how a warrant moves in relation to the underlying stock/index. Puts have negative deltas because their prices increase as the underlying stock/index falls. Note, if your warrant has a WPS that this will need to be taken into account.
                      </p>
                    </div>
                  </ReactTooltip>
                </div>
              </th>
              <th className="bgcolor-06" style={{ width: '6.0%' }}>
                <div
                  data-tip
                  data-for="indicator-ss-tooltip"
                >
                  <span className="ttip" data-target="sensitivity">Sensitivity</span>
                  <ReactTooltip
                    id="indicator-ss-tooltip"
                    className="tools-search-tooltip"
                    delayHide={100}
                    place="right"
                    type="warning"
                    effect="solid"
                  >
                    <div>
                      <p>
                        <strong>Sensitivity: </strong>
                        Shows you how much the underlying stock or index must move for your warrant to move one "tick" or "Spread". For warrants that cost less than $0.200, one tick is $0.001.
                      </p>
                    </div>
                  </ReactTooltip>
                </div>
              </th>
              <th className="bgcolor-06" style={{ width: '4.6%' }}>
                <div
                  data-tip
                  data-for="indicator-eg-tooltip"
                >
                  <span className="ttip" data-target="effectivegearing">Eff. gearing<br />(x)</span>
                  <ReactTooltip
                    id="indicator-eg-tooltip"
                    className="tools-search-tooltip"
                    delayHide={100}
                    place="right"
                    type="warning"
                    effect="solid"
                  >
                    <div>
                      <p style={{ textAlign: 'left' }}>
                        <strong>Effective gearing: </strong>
                        Indicates your leveraged exposure. An effective gearing of 5X tells you a 1% move in the underlying stock/index results in an approximate 5% move in your Warrant price. <a href="/WarrantsGuidebook/effectivegearing" target="_blank">Click here </a>to learn more about effective gearing.
                      </p>
                    </div>
                  </ReactTooltip>
                </div>
              </th>
              <th className="bgcolor-06" style={{ width: '6.0%' }}>
                <div
                  data-tip
                  data-for="indicator-iv-tooltip"
                >
                  <span className="ttip" data-target="impliedvolatility">Volatility<br />(%)</span>
                  <ReactTooltip
                    id="indicator-iv-tooltip"
                    className="tools-search-tooltip"
                    delayHide={100}
                    place="right"
                    type="warning"
                    effect="solid"
                  >
                    <div>
                      <p style={{ textAlign: 'left' }}>
                        <strong>Volatility: </strong>
                        the higher the price of the Warrant. Relates to the volatility and risk of the underlying share/Index.<a href="/WarrantsGuidebook/impliedvolatility" target="_blank"> Click here </a>to learn more about implied volatility.
                      </p>
                    </div>
                  </ReactTooltip>
                </div>
              </th>
              <th className="bgcolor-06" style={{ width: '6.0%' }}>
                <div
                  data-tip
                  data-for="indicator-WARRANT-tooltip"
                >
                  <span className="ttip" data-target="estimateddecay">Estimated decay</span>
                  <ReactTooltip
                    id="indicator-WARRANT-tooltip"
                    className="tools-search-tooltip"
                    delayHide={100}
                    place="right"
                    type="warning"
                    effect="solid"
                  >
                    <div>
                      <p>
                        <strong>Estimated decay: </strong>
                        {/* The estimated average time decay for the warrant over the next 5 days. */}
                        Estimated drop in warrant value per day
                      </p>
                    </div>
                  </ReactTooltip>
                </div>
              </th>
            </tr>
            <tr className="result-sort visible-lg  visible-md" >
              <th>
                <span className="icon-sort glyphicon glyphicon-triangle-bottom result-sort-down"
                  onClick={() => { this.onSorting('wcode', 'desc') }}></span>
                <span className='icon-sort glyphicon glyphicon-triangle-top result-sort-up'
                  onClick={() => { this.onSorting('wcode', 'asc') }}></span>
              </th>
              <th></th>
              <th>
                <span className="icon-sort glyphicon glyphicon-triangle-bottom result-sort-down"
                  onClick={() => { this.onSorting('ucode', 'desc') }}></span>
                <span className='icon-sort glyphicon glyphicon-triangle-top result-sort-up'
                  onClick={() => { this.onSorting('ucode', 'asc') }}></span>
              </th>
              <th>
                <span className="icon-sort glyphicon glyphicon-triangle-bottom result-sort-down"
                  onClick={() => { this.onSorting('type', 'desc') }}></span>
                <span className='icon-sort glyphicon glyphicon-triangle-top result-sort-up'
                  onClick={() => { this.onSorting('type', 'asc') }}></span>
              </th>
              <th>
                <span className="icon-sort glyphicon glyphicon-triangle-bottom result-sort-down"
                  onClick={() => { this.onSorting('ep', 'desc') }}></span>
                <span className='icon-sort glyphicon glyphicon-triangle-top result-sort-up'
                  onClick={() => { this.onSorting('ep', 'asc') }}></span>
              </th>
              <th>
                <span className="icon-sort glyphicon glyphicon-triangle-bottom result-sort-down"
                  onClick={() => { this.onSorting('dwps', 'desc') }}></span>
                <span className='icon-sort glyphicon glyphicon-triangle-top result-sort-up'
                  onClick={() => { this.onSorting('dwps', 'asc') }}></span>
              </th>
              <th>
                <span className="icon-sort glyphicon glyphicon-triangle-bottom result-sort-down"
                  onClick={() => { this.onSorting('ldate', 'desc') }}></span>
                <span className='icon-sort glyphicon glyphicon-triangle-top result-sort-up'
                  onClick={() => { this.onSorting('ldate', 'asc') }}></span>
              </th>
              <th>
                <span className="icon-sort glyphicon glyphicon-triangle-bottom result-sort-down"
                  onClick={() => { this.onSorting('isr', 'desc') }}></span>
                <span className='icon-sort glyphicon glyphicon-triangle-top result-sort-up'
                  onClick={() => { this.onSorting('isr', 'asc') }}></span>
              </th>
              <th>
                <span className="icon-sort glyphicon glyphicon-triangle-bottom result-sort-down"
                  onClick={() => { this.onSorting('bv', 'desc') }}></span>
                <span className='icon-sort glyphicon glyphicon-triangle-top result-sort-up'
                  onClick={() => { this.onSorting('bv', 'asc') }}></span>
              </th>
              <th>
                <span className="icon-sort glyphicon glyphicon-triangle-bottom result-sort-down"
                  onClick={() => { this.onSorting('bp', 'desc') }}></span>
                <span className='icon-sort glyphicon glyphicon-triangle-top result-sort-up'
                  onClick={() => { this.onSorting('bp', 'asc') }}></span>
              </th>
              <th>
                <span className="icon-sort glyphicon glyphicon-triangle-bottom result-sort-down"
                  onClick={() => { this.onSorting('ap', 'desc') }}></span>
                <span className='icon-sort glyphicon glyphicon-triangle-top result-sort-up'
                  onClick={() => { this.onSorting('ap', 'asc') }}></span>
              </th>
              <th>
                <span className="icon-sort glyphicon glyphicon-triangle-bottom result-sort-down"
                  onClick={() => { this.onSorting('av', 'desc') }}></span>
                <span className='icon-sort glyphicon glyphicon-triangle-top result-sort-up'
                  onClick={() => { this.onSorting('av', 'asc') }}></span>
              </th>
              <th>
                <span className="icon-sort glyphicon glyphicon-triangle-bottom result-sort-down"
                  onClick={() => { this.onSorting('tv', 'desc') }}></span>
                <span className='icon-sort glyphicon glyphicon-triangle-top result-sort-up'
                  onClick={() => { this.onSorting('tv', 'asc') }}></span>
              </th>
              <th>
                <span className="icon-sort glyphicon glyphicon-triangle-bottom result-sort-down"
                  onClick={() => { this.onSorting('pc', 'desc') }}></span>
                <span className='icon-sort glyphicon glyphicon-triangle-top result-sort-up'
                  onClick={() => { this.onSorting('pc', 'asc') }}></span>
              </th>
              <th>
                <span className="icon-sort glyphicon glyphicon-triangle-bottom result-sort-down"
                  onClick={() => { this.onSorting('dlt', 'desc') }}></span>
                <span className='icon-sort glyphicon glyphicon-triangle-top result-sort-up'
                  onClick={() => { this.onSorting('dlt', 'asc') }}></span>
              </th>
              <th>
                <span className="icon-sort glyphicon glyphicon-triangle-bottom result-sort-down"
                  onClick={() => { this.onSorting('ss', 'desc') }}></span>
                <span className='icon-sort glyphicon glyphicon-triangle-top result-sort-up'
                  onClick={() => { this.onSorting('ss', 'asc') }}></span>
              </th>
              <th>
                <span className="icon-sort glyphicon glyphicon-triangle-bottom result-sort-down"
                  onClick={() => { this.onSorting('eg', 'desc') }}></span>
                <span className='icon-sort glyphicon glyphicon-triangle-top result-sort-up'
                  onClick={() => { this.onSorting('eg', 'asc') }}></span>
              </th>
              <th>
                <span className="icon-sort glyphicon glyphicon-triangle-bottom result-sort-down"
                  onClick={() => { this.onSorting('iv', 'desc') }}></span>
                <span className='icon-sort glyphicon glyphicon-triangle-top result-sort-up'
                  onClick={() => { this.onSorting('iv', 'asc') }}></span>
              </th>
              <th>
                <span className="icon-sort glyphicon glyphicon-triangle-bottom result-sort-down"
                  onClick={() => { this.onSorting('tt', 'desc') }}></span>
                <span className='icon-sort glyphicon glyphicon-triangle-top result-sort-up'
                  onClick={() => { this.onSorting('tt', 'asc') }}></span>
              </th>
            </tr>

            <tr className="visible-sm">
              <th className="bgcolor-04" colSpan="7">
                GENERAL
              </th>
              <th className="bgcolor-05" colSpan="6">
                MARKET
              </th>
              <th className="bgcolor-06" colSpan="2">
                WARRANT
              </th>
            </tr>
            <tr className="result-hdr2 visible-sm" >
              <th className="bgcolor-04" style={{ width: '5.15%' }}>
                Warrant<br />code
              </th>
              <th className="bgcolor-04 noborder" style={{ width: '4%' }}></th>
              <th className="bgcolor-04" style={{ width: '3%' }}>
                Type
              </th>
              <th className="bgcolor-04" style={{ width: '6.1%' }}>
                Ex.<br />price<br />
              </th>
              <th className="bgcolor-04" style={{ width: '4.1%' }}>
                Ex.<br />ratio
              </th>
              <th className="bgcolor-04" style={{ width: '6.1%' }}>
                Last<br />trading<br />date
              </th>
              <th className="bgcolor-04" style={{ width: '6.45%' }}>
                Issuer
              </th>
              <th className="bgcolor-05" style={{ width: '6.1%' }}>
                Bid<br />volume<br />('000)
              </th>
              <th className="bgcolor-05" style={{ width: '5.1%' }}>
                Bid<br />(SGD)
              </th>
              <th className="bgcolor-05" style={{ width: '6.1%' }}>
                Ask<br />(SGD)
              </th>
              <th className="bgcolor-05" style={{ width: '5.1%' }}>
                Ask<br />volume<br />('000)
              </th>
              <th className="bgcolor-05" style={{ width: '6.1%' }}>
                Traded <br />volume<br />('000)
              </th>
              <th className="bgcolor-05" style={{ width: '5%' }}>
                Price change<br />(%)
              </th>
              <th className="bgcolor-06" style={{ width: '4.6%' }}>
                Eff. gearing<br />(x)
              </th>
              <th className="bgcolor-06" style={{ width: '6.0%' }}>
                Volatility<br />(%)
              </th>
            </tr>
            <tr className="result-sort visible-sm" >
              <th>
                <span className="icon-sort-xs glyphicon glyphicon-triangle-bottom"
                  onClick={() => { this.onSorting('wcode', 'desc') }}></span>
                <span className='icon-sort-xs glyphicon glyphicon-triangle-top'
                  onClick={() => { this.onSorting('wcode', 'asc') }}></span>
              </th>
              <th></th>
              <th>
                <span className="icon-sort-xs glyphicon glyphicon-triangle-bottom"
                  onClick={() => { this.onSorting('type', 'desc') }}></span>
                <span className='icon-sort-xs glyphicon glyphicon-triangle-top'
                  onClick={() => { this.onSorting('type', 'asc') }}></span>
              </th>
              <th>
                <span className="icon-sort-xs glyphicon glyphicon-triangle-bottom"
                  onClick={() => { this.onSorting('ep', 'desc') }}></span>
                <span className='icon-sort-xs glyphicon glyphicon-triangle-top'
                  onClick={() => { this.onSorting('ep', 'asc') }}></span>
              </th>
              <th>
                <span className="icon-sort-xs glyphicon glyphicon-triangle-bottom"
                  onClick={() => { this.onSorting('dwps', 'desc') }}></span>
                <span className='icon-sort-xs glyphicon glyphicon-triangle-top'
                  onClick={() => { this.onSorting('dwps', 'asc') }}></span>
              </th>
              <th>
                <span className="icon-sort-xs glyphicon glyphicon-triangle-bottom"
                  onClick={() => { this.onSorting('ldate', 'desc') }}></span>
                <span className='icon-sort-xs glyphicon glyphicon-triangle-top'
                  onClick={() => { this.onSorting('ldate', 'asc') }}></span>
              </th>
              <th>
                <span className="icon-sort-xs glyphicon glyphicon-triangle-bottom"
                  onClick={() => { this.onSorting('isr', 'desc') }}></span>
                <span className='icon-sort-xs glyphicon glyphicon-triangle-top'
                  onClick={() => { this.onSorting('isr', 'asc') }}></span>
              </th>
              <th>
                <span className="icon-sort-xs glyphicon glyphicon-triangle-bottom"
                  onClick={() => { this.onSorting('bv', 'desc') }}></span>
                <span className='icon-sort-xs glyphicon glyphicon-triangle-top'
                  onClick={() => { this.onSorting('bv', 'asc') }}></span>
              </th>
              <th>
                <span className="icon-sort-xs glyphicon glyphicon-triangle-bottom"
                  onClick={() => { this.onSorting('bp', 'desc') }}></span>
                <span className='icon-sort-xs glyphicon glyphicon-triangle-top'
                  onClick={() => { this.onSorting('bp', 'asc') }}></span>
              </th>
              <th>
                <span className="icon-sort-xs glyphicon glyphicon-triangle-bottom"
                  onClick={() => { this.onSorting('ap', 'desc') }}></span>
                <span className='icon-sort-xs glyphicon glyphicon-triangle-top'
                  onClick={() => { this.onSorting('ap', 'asc') }}></span>
              </th>
              <th>
                <span className="icon-sort-xs glyphicon glyphicon-triangle-bottom"
                  onClick={() => { this.onSorting('av', 'desc') }}></span>
                <span className='icon-sort-xs glyphicon glyphicon-triangle-top'
                  onClick={() => { this.onSorting('av', 'asc') }}></span>
              </th>
              <th>
                <span className="icon-sort-xs glyphicon glyphicon-triangle-bottom"
                  onClick={() => { this.onSorting('tv', 'desc') }}></span>
                <span className='icon-sort-xs glyphicon glyphicon-triangle-top'
                  onClick={() => { this.onSorting('tv', 'asc') }}></span>
              </th>
              <th>
                <span className="icon-sort-xs glyphicon glyphicon-triangle-bottom"
                  onClick={() => { this.onSorting('pc', 'desc') }}></span>
                <span className='icon-sort-xs glyphicon glyphicon-triangle-top'
                  onClick={() => { this.onSorting('pc', 'asc') }}></span>
              </th>
              <th>
                <span className="icon-sort-xs glyphicon glyphicon-triangle-bottom"
                  onClick={() => { this.onSorting('eg', 'desc') }}></span>
                <span className='icon-sort-xs glyphicon glyphicon-triangle-top'
                  onClick={() => { this.onSorting('eg', 'asc') }}></span>
              </th>
              <th>
                <span className="icon-sort-xs glyphicon glyphicon-triangle-bottom"
                  onClick={() => { this.onSorting('iv', 'desc') }}></span>
                <span className='icon-sort-xs glyphicon glyphicon-triangle-top'
                  onClick={() => { this.onSorting('iv', 'asc') }}></span>
              </th>
            </tr>

            <tr className="result-hdr2 visible-xs">
              <th className="col-clickable">
                Warrant<br />code
              </th>
              <th className="col-clickable">
              </th>
              <th className="col-clickable">
                <div
                  data-tip
                  data-for="indicator-underlying-tooltip"
                >
                  {/* <span className="ttip" data-target="underlying">{size=='xs'?'Underlying name':'Underlying'}</span> */}
                  <span className="ttip" data-target="underlying">Underlying</span>
                  <ReactTooltip
                    id="indicator-underlying-tooltip"
                    className="tools-search-tooltip"
                    delayHide={100}
                    place="right"
                    type="warning"
                    effect="solid"
                  >
                    <div>
                      <p>
                        <strong>Underlying: </strong>
                        The stock or index over which the Warrant is listed.
                      </p>
                    </div>
                  </ReactTooltip>
                </div>
              </th>
              <th className="col-clickable">type</th>
              <th className="col-clickable">Strike</th>
              <th className="col-clickable">Last<br />trading<br />date</th>
              <th className="col-clickable">Bid</th>
              <th className="col-clickable">Traded volume<br />('000)</th>
            </tr>
            <tr className="result-sort visible-xs" key={"result-sort-" + 'sm'}>
              <th>
                <span className="icon-sort-xs glyphicon glyphicon-triangle-bottom"
                  onClick={() => { this.onSorting('wcode', 'desc') }}></span>
                <span className='icon-sort-xs glyphicon glyphicon-triangle-top'
                  onClick={() => { this.onSorting('wcode', 'asc') }}></span>
              </th>
              <th></th>
              <th>
                <span className="icon-sort-xs glyphicon glyphicon-triangle-bottom"
                  onClick={() => { this.onSorting('ucode', 'desc') }}></span>
                <span className='icon-sort-xs glyphicon glyphicon-triangle-top'
                  onClick={() => { this.onSorting('ucode', 'asc') }}></span>
              </th>
              <th>
                <span className="icon-sort-xs glyphicon glyphicon-triangle-bottom"
                  onClick={() => { this.onSorting('type', 'desc') }}></span>
                <span className='icon-sort-xs glyphicon glyphicon-triangle-top'
                  onClick={() => { this.onSorting('type', 'asc') }}></span>
              </th>
              <th>
                <span className="icon-sort-xs glyphicon glyphicon-triangle-bottom"
                  onClick={() => { this.onSorting('ep', 'desc') }}></span>
                <span className='icon-sort-xs glyphicon glyphicon-triangle-top'
                  onClick={() => { this.onSorting('ep', 'asc') }}></span>
              </th>
              <th>
                <span className="icon-sort-xs glyphicon glyphicon-triangle-bottom"
                  onClick={() => { this.onSorting('ldate', 'desc') }}></span>
                <span className='icon-sort-xs glyphicon glyphicon-triangle-top'
                  onClick={() => { this.onSorting('ldate', 'asc') }}></span>
              </th>
              <th>
                <span className="icon-sort-xs glyphicon glyphicon-triangle-bottom"
                  onClick={() => { this.onSorting('bp', 'desc') }}></span>
                <span className='icon-sort-xs glyphicon glyphicon-triangle-top'
                  onClick={() => { this.onSorting('bp', 'asc') }}></span>
              </th>
              <th>
                <span className="icon-sort-xs glyphicon glyphicon-triangle-bottom"
                  onClick={() => { this.onSorting('tv', 'desc') }}></span>
                <span className='icon-sort-xs glyphicon glyphicon-triangle-top'
                  onClick={() => { this.onSorting('tv', 'asc') }}></span>
              </th>
            </tr>
          </thead>

          <tbody>
            {
              !this.props.isLoading && this.props.result && this.props.result.map((value, index) => {
                return (
                  <tr
                    className={"rowtmpl-lg" + ' ' + " text-bold"}
                  >
                    <td >
                      <a href={"/tools/livematrix/" + value.dwSymbol}>{value.dwSymbol}</a>
                    </td>
                    {/* hidden-xs */}
                    <td className="">
                      {
                        value.HIGHLQDY && <span className="indicator-item-icon ttip icon-liquidity" data-target="highestliquidity" data-tip
                          data-for="li-tooltip"
                          data-hasqtip="107" key={"icon-liquidity-" + index}>
                          <ReactTooltip
                            id="li-tooltip"
                            className="search-tooltip"
                            delayHide={100}
                            place="right"
                            type="warning"
                            effect="solid"
                          >
                            <div style={{ fontFamily: "'HelveticaNeueLight','HelveticaNeue','Roboto', Arial, sans-serif" }}>
                              <p>
                                <strong style={{ fontWeight: 600 }}>Highest liquidity:</strong> Highlights the Macquarie warrant for each underlying with the largest volumes on the current bid and offer.
                              </p>
                            </div>
                          </ReactTooltip>
                        </span>
                      }
                      {
                        value.LOWTIMEDECAY && <span className="indicator-item-icon ttip icon-lowtimedecay" data-target="lowtimedecay" data-tip
                          data-for="lowtimedecay-tooltip"
                          data-hasqtip="107" key={"icon-lowtimedecay-" + index}>
                          <ReactTooltip
                            id="lowtimedecay-tooltip"
                            className="search-tooltip"
                            delayHide={100}
                            place="right"
                            type="warning"
                            effect="solid"
                          >
                            <div>
                              <p>
                                <strong>Low time decay:</strong> Warrants with this indicator have relatively lower time decay, meaning lower holding costs for investors. Generally, all else constant, longer dated Warrants have lower time decay than shorter dated Warrants and vice versa.
                              </p>
                            </div>
                          </ReactTooltip>
                        </span>
                      }
                      {
                        value.SoldOut && <span className="indicator-item-icon ttip icon-soldOut" data-target="soldOut" data-tip
                          data-for="soldOut-tooltip"
                          data-hasqtip="107" key={"icon-soldOut-" + index}>
                          <ReactTooltip
                            id="soldOut-tooltip"
                            className="search-tooltip"
                            delayHide={100}
                            place="right"
                            type="warning"
                            effect="solid"
                          >
                            <div>
                              <p>
                                <strong>Inventory sold-out:</strong> Warrants with this indicator are either sold out or close to being sold out, meaning the market maker may no longer provide an offer price or have widened spreads by raising the offer price. Existing holders are not disadvantaged as the bid price is still maintained at its fair price. However, please exercise caution if you are looking to buy this SW as the market price may be inflated by other investors queuing in the market. Do check the Live Matrix for the warrant’s fair bid price.
                              </p>
                            </div>
                          </ReactTooltip>
                        </span>
                      }
                      {
                        value.APPCHEXPRY && <span className="indicator-item-icon ttip icon-expiry" data-target="nearexpiry" data-tip
                          data-for="ne-tooltip"
                          data-hasqtip="" key={"icon-expiry-" + index}>
                          <ReactTooltip
                            id="ne-tooltip"
                            className="search-tooltip"
                            delayHide={100}
                            place="right"
                            type="warning"
                            effect="solid"
                          >
                            <div style={{ fontFamily: "'HelveticaNeueLight','HelveticaNeue','Roboto', Arial, sans-serif" }}>
                              <p>
                                <strong style={{ fontWeight: 600 }}>Near expiry:</strong>Macquarie warrants with less than 1 month to expiry. These tend to be very high risk, so please trade with caution.
                              </p>
                            </div>
                          </ReactTooltip>
                        </span>
                      }
                      {
                        value.HIGHRESP && <span className="indicator-item-icon ttip icon-responsive" data-target="responsive" data-tip
                          data-for="re-tooltip"
                          data-hasqtip="" key={"icon-responsive-" + index}>
                          <ReactTooltip
                            id="re-tooltip"
                            className="search-tooltip"
                            delayHide={100}
                            place="right"
                            type="warning"
                            effect="solid"
                          >
                            <div style={{ fontFamily: "'HelveticaNeueLight','HelveticaNeue','Roboto', Arial, sans-serif" }}>
                              <p>
                                <strong style={{ fontWeight: 600 }}>Responsive:</strong> Indicates the Macquarie warrant that is most sensitive to the underlying price movements for each underlying. This is usually the one with the smallest number in the “Sensitivity” field.
                              </p>
                            </div>
                          </ReactTooltip>
                        </span>
                      }
                      {
                        value.HOTLIST && <span className="indicator-item-icon ttip icon-hotlist" data-target="hotdw" data-tip
                          data-for="hot-tooltip"
                          data-hasqtip="40" key={"icon-hotlists-" + index}>
                          <ReactTooltip
                            id="hot-tooltip"
                            className="search-tooltip"
                            delayHide={100}
                            place="right"
                            type="warning"
                            effect="solid"
                          >
                            <div style={{ fontFamily: "'HelveticaNeueLight','HelveticaNeue','Roboto', Arial, sans-serif" }}>
                              <p>
                                <strong style={{ fontWeight: 600 }}>Trending warrants:</strong> The Trending warrants are chosen based on the warrants’ gearing, liquidity, sensitivity and are on tighter spreads
                              </p>
                            </div>
                          </ReactTooltip>
                        </span>
                      }
                    </td>
                    <td className="visible-lg  visible-md visible-xs">
                      <a href={'/tools/underlying/' + value.underlyingSymbol}>{value.underlyingSymbol_value}</a>
                    </td>
                    <td >{value.type}</td>
                    <td >{MQSGUtil.formatNumberDisplay(value.underlying_name == 'TENCENT' ? value.exercise_price_cal : value.exercisePrice, 3)}</td>
                    <td className="hidden-xs">{MQSGUtil.formatNumberDisplay(value.underlying_name == 'TENCENT' ? value.dwps : value.dwps, 3, "-", true, false)}</td>
                    <td >{value.ltDate}</td>
                    <td className="bordered hidden-xs">{value.issuer}</td>

                    <td className="hidden-xs">{MQSGUtil.formatNumberDisplay(value.bidVolume_f)}</td>
                    <td >{MQSGUtil.formatNumberDisplay(value.bidPrice_f, 3)}</td>
                    <td className="hidden-xs">{MQSGUtil.formatNumberDisplay(value.askPrice_f, 3)}</td>
                    <td className="hidden-xs">{MQSGUtil.formatNumberDisplay(value.askVolume_f)}</td>
                    <td >{MQSGUtil.formatNumberDisplay(value.tradeVolume_f)}</td>
                    <td className={'bordered visible-lg  visible-md hidden-xs' + this.getUpOrDownClass(value.priceChange_f)}>{MQSGUtil.formatNumberDisplay(value.priceChange_f, 2)}</td>

                    <td className={'hidden-xs ' + this.getUpOrDownClass(value.delta)}>{MQSGUtil.formatNumberDisplay(value.delta)}</td>
                    <td className="visible-lg  visible-md hidden-xs">{MQSGUtil.formatNumberDisplay(value.sensitivity)}</td>
                    <td className="hidden-xs">{MQSGUtil.formatNumberDisplay(value.effectiveGearing)}</td>
                    <td className="hidden-xs">{MQSGUtil.formatNumberDisplay(value.impliedVolalitiy)}</td>
                    <td className="visible-lg  visible-md hidden-xs">{MQSGUtil.formatNumberDisplay(value.tt, 4)}</td>
                  </tr>
                )
              })
            }
          </tbody>
        </table>
        {this.props.isLoading && (
          <div className="loader-div">
            <LoaderSpin isLoading={this.props.isLoading} isVisible />
          </div>
        )}
        <div className="result-disclaimer hidden-xs hidden-sm">
          <p className="small">
            ** The Price Change (%) is calculated using the current bid price
            for the warrant compared to the previous day's closing bid price. At
            the end of each trading day, we capture the bid price of the warrant
            slightly before the close of trading and use this to represent the
            'closing price'. The relevant times are: 4:58pm for Singapore
            underlyings, Nikkei warrants and S&amp;P 500® warrants, 4:28pm for
            HSI warrants. This will provide the most accurate reference point
            for investors to track price movements of the Warrant. For more info{" "}
            <a
              target="_blank"
              style={{ color: '#0675C2' }}
              href="/WarrantsGuidebook/closingtimestonote"
            >
              click here
            </a>
            .
            <br />
            <br />* The exercise prices and WarrantPS in the above table in some
            cases have been rounded to fit the page. Please click on the code to
            go to the Warrant terms page for the full rounding.
          </p>
          <hr />
          <p className="small">
            All market data is delayed 2 mins unless otherwise indicated by timestamp.
          </p>
        </div>
      </div>
    );
  }
}
export default withRouter(WarrantSearch);
// 1. Data
//      1.1 fetch
//      1.2 estimated decay (rounding ?)
//      1.3 Issuer (MBL) > display as (MACQ) ?
// 2. Sorting
// 3. tooltip
// xs (<768)
// sm (>=768)
// md (>=992)
// lg (>=1200)
